import React from "react"
import { graphql, Link } from "gatsby"
import Img from "gatsby-image"

import Layout from "../components/layout"

import SEO from "../components/seo"

export default ({ data }) => (
  <Layout>
    <SEO />
    <section className="hero">
      <figure>
        <Img fluid={data.hero.childImageSharp.fluid} alt="" style={{ height: "100%" }} />
      </figure>
      <div className="catch">
        <h1>ChaNmA Blog</h1>
      </div>
      <div className="wave">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1366 229.5" fill="#fff"><path d="M1369,6.3C1222.5-12.2,1189.5,8,919.2,96.6C665,179.8,160,141.7-2,53.1v150l1371-14.2V6.3z" opacity=".53" /><path d="M1369 229.5V55.8c-9.5-2.4-19.2-4.4-28.9-5.8-196.9-29.9-203.4-15.8-503.9 82.6-219.8 72-627.6 53.2-838.2-10.5v107.4h1371z" /></svg>
      </div>
    </section>
    <section className="food">
      <div className="container">
        <h2 className="bar food">
          Latest Article</h2>
      </div>
    </section>
    <section>
      <div className="container">
        <h2 className="sr-only">RECENT POSTS</h2>
        <div className="posts">
          {data.allContentfulBlogPost.edges.map(({ node }) => (
            <article className="post">
              <Link to={`/blog/post/${node.slug}/`}>
                <figure>
                  <Img
                    fluid={node.eyecatch.fluid}
                    alt={node.eyecatch.description}
                    style={{ height: "100%" }}
                  />
                </figure>
                <h3>{node.title}</h3>
              </Link>
            </article>
          ))}
        </div>
      </div>
    </section>
    <section className="food">
      <div className="container">
        <div className="profile">
          <h2 className="bar">
            Profile</h2>
          <h3>ちゃんま</h3>
          <p>Webに関することを学んでいる学生です！</p>
          <p>岐阜県の田舎で育ち、今は愛知県の名古屋市で一人暮らしをしています！</p>
        </div>
      </div>
    </section>
  </Layout>
)

export const query = graphql`
query {
  hero: file(relativePath: {eq: "hero.jpg"}) {
    childImageSharp {
      fluid(maxWidth: 1600) {
        ...GatsbyImageSharpFluid_withWebp
      }
    }
  }
    pattern: file(relativePath: {eq: "pattern.jpg"}) {
    childImageSharp {
      fluid(maxWidth: 1920, quality: 90) {
        ...GatsbyImageSharpFluid_withWebp
      }
    }
  }
   allContentfulBlogPost(sort: { order: DESC, fields: publishDate }
        skip: 0
        limit: 4
    ) {
        edges{
            node{
                title
                id
                slug
                eyecatch {
                    fluid(maxWidth: 573) {
                        ...GatsbyContentfulFluid_withWebp
                    }
                    description
                }
            }
        }
    }
}
`
